import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'antd';

const ShowMessage = (props) => {
  const { message, img_src, title, fade_item, show_button, button_text, button_type, button_class, button_size, button_loading, handleButtonClick, height, width } = props;

  return (
    <div className="ori-animated ori-fade-in ori-full-parent-height ori-pad-20 ori-flex-column ori-flex-center">
      <div className={classNames("ori-b-mrgn-10", { "ori-opacity-medium": fade_item })}>
        {
          img_src &&
          <div className="ori-bg-no-repeat ori-bg-size-contain ori-bg-position-center" style={{ height: height + 'px', width: width + 'px', backgroundImage: `url(${img_src})` }} />
        }
      </div>
      {
        title &&
        <p className="ori-text-center ori-font-md ori-font-bold ori-capitalize-first">{title}</p>
      }
      <p className="ori-capitalize-first ori-text-center">{message}</p>
      {
        show_button &&
        <div className="ori-flex-row ori-flex-jc ori-full-width ori-tb-pad-10">
          <Button size={button_size} type={button_type} loading={button_loading} className={button_class} onClick={handleButtonClick}>{button_text}</Button>
        </div>
      }
    </div>
  );
}

ShowMessage.propTypes = {
  message: PropTypes.string,
  img_src: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string,
  fade_item: PropTypes.bool,
  show_button: PropTypes.bool,
  button_text: PropTypes.string,
  button_class: PropTypes.string,
  button_type: PropTypes.string,
  button_size: PropTypes.oneOf(['small', 'large', 'default']),
  button_loading: PropTypes.bool,
  handleButtonClick: PropTypes.func,
  height: PropTypes.number,
  width: PropTypes.number,
};

ShowMessage.defaultProps = {
  show_button: false,
  button_type: "default",
  button_text: "Go Back",
  button_loading: false,
  height: 70,
  width: 70,
};

export default ShowMessage;



// WEBPACK FOOTER //
// ./src/components/showmessage/index.js